import Axios, { type AxiosInstance, type AxiosRequestConfig } from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getToken, removeToken } from './cookie_storage'

export function toSSOLogin() {
  window.location.href = `/login`
}

interface IAxiosRequestConfig extends AxiosRequestConfig {
  showError?: boolean
}

interface GdAxiosInstance extends AxiosInstance {
  // 重载一下返回
  (config: IAxiosRequestConfig): Promise<any>
  get(url: string, config?: IAxiosRequestConfig): Promise<any>
  post(url: string, data?: any, config?: IAxiosRequestConfig): Promise<any>
}

const defaultBaseURL = import.meta.env.VITE_API_URL

const axios: GdAxiosInstance = Axios.create({
  baseURL: defaultBaseURL,
  timeout: 20000 // 请求超时 20s
})

// 前置拦截器（发起请求之前的拦截）
axios.interceptors.request.use(
  (config: IAxiosRequestConfig): any => {
    const token = getToken()
    const configProps = config || {}
    configProps.params = config.params ? config.params : {}
    configProps.headers && (configProps.headers['token'] = token) // Add a semicolon here

    return configProps
  },
  (error) => Promise.reject(error)
)

// 后置拦截器（获取到响应时的拦截）
axios.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      const code = response?.data?.code
      const config: IAxiosRequestConfig = response?.config

      if (code === 401 || code === 10005) {
        removeToken()
        return toSSOLogin()
      } else if (code === 403) {
        alert(JSON.stringify(response.data))
        window.location.href = '/403'
      } else if (code && code !== 0) {
        // 普通后台报错
        console.log(response.data)
        const errMessage = response?.data?.msg || ''
        config.showError !== false &&
          ElMessageBox.alert(`${errMessage}`, '提示', {
            type: 'error',
            showClose: false,
            customClass: 'message-box-z-index',
            callback: () => {}
          })
        return Promise.reject(response.data)
      }
    }

    return response.data.data
  },
  (error) => {
    if (error.response && error.response.data) {
      const code = error.response.status
      const msg = error.response.data.msg
      // 会话过期
      if (code === 401) {
        removeToken()
        toSSOLogin()
        return
      }
      ElMessage.error(`Code: ${code}, Message: ${msg}`)
    } else if (error) ElMessage.error(`${error}`)
    return Promise.reject(error)
  }
)

export default axios
